namespace TabAurous.SalesOrder {
    export namespace SalesOrderRegisterService {
        export const baseUrl = 'SalesOrder/SalesOrderRegister';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "SalesOrder/SalesOrderRegister/List",
            PartyList = "SalesOrder/SalesOrderRegister/PartyList"
        }

        [
            'List', 
            'PartyList'
        ].forEach(x => {
            (<any>SalesOrderRegisterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
